import { Component } from "react";
import withAuth from "../../components/withAuth";
import { compose } from "redux";
import { connect } from "react-redux";
import "../../utils.css";
import "./EquipmentEPIForm.css";
import { getCurrentFunctionName } from "../../performanceModeManager";
import Button from "@mui/material/Button";
import EPIFormSection from "../../components/EPI/EPIFormSection";
import EPIFormDocumentSection from "../../components/EPI/EPIFormDocumentSection";
import { responseValueChange, validateEquipmentInspection } from "../../redux/epi/epiEditionActions";
import { clone } from "../../utils";
import moment from "moment";
import { Divider, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

const CustomTypography = styled(Typography)(({ theme }) => ({
    "&.MuiTypography-root": {
        fontWeight: 500,
    },
}));

class EquipmentEPIForm extends Component {
    constructor(props) {
        super(props);

        if (!this.props.form) {
            this.props.history.push("/epis");
        }
    }

    responseValueChange(sectionId, metaQuestion) {
        this.props.responseValueChange(sectionId, metaQuestion, this.props.sections);
    }

    validate() {
        this.props.validateEquipmentInspection(
            this.props.form,
            this.props.sections,
            this.props.currentEquipmentInspection,
            this.props.activeUser,
            this.props.history
        );
    }

    render() {
        console.perfLog(getCurrentFunctionName());

        let formContent = "";
        if (!this.props.form) {
            formContent = <div />;
        } else {
            let sectionsElements = [];
            let pdfListAtStart = [];
            let pdfListAtEnd = [];

            let sortedSections = clone(this.props.sections);

            sortedSections.sort((s) => {
                s.squence;
            });

            sortedSections.forEach((s, i) => {
                sectionsElements.push(
                    <div>
                        {i !== 0 && sortedSections.length > 1 ? (
                            <Divider
                                sx={{ borderBottomWidth: "thick", borderColor: "#000000", marginBottom: "15px" }}
                            />
                        ) : (
                            ""
                        )}
                        <EPIFormSection
                            key={s.id}
                            id={"section-" + s.id}
                            currentSectionId={s.id}
                            responseValueChange={this.responseValueChange.bind(this)}
                        />
                    </div>
                );
            });

            this.props.form.survey.pdf_list_ids.forEach(async (p) => {
                let documentSection = (
                    <EPIFormDocumentSection key={p.internalId} document={p} internalId={p.internalId} />
                );

                if (p.location === "end") pdfListAtEnd.push(documentSection);
                else pdfListAtStart.push(documentSection);
            });

            formContent = (
                <div className="container-with-footer">
                    {pdfListAtStart.length > 0 ? (
                        <div className="main-div-part">
                            <CustomTypography variant="h5">Annexes</CustomTypography>
                            {pdfListAtStart.map((p) => p)}
                        </div>
                    ) : null}
                    <div className="main-div-part">
                        {pdfListAtStart.length > 0 && sortedSections.length > 0 ? (
                            <Divider
                                sx={{ borderBottomWidth: "thick", borderColor: "#000000", marginBottom: "15px" }}
                            />
                        ) : (
                            ""
                        )}
                        {sectionsElements.map((be) => be)}
                    </div>
                    {pdfListAtEnd.length > 0 ? (
                        <div className="main-div-part">
                            {pdfListAtEnd.length > 0 && sortedSections.length > 0 ? (
                                <Divider
                                    sx={{ borderBottomWidth: "thick", borderColor: "#000000", marginBottom: "15px" }}
                                />
                            ) : (
                                ""
                            )}
                            <CustomTypography variant="h5">Annexes</CustomTypography>
                            {pdfListAtEnd.map((p) => p)}
                        </div>
                    ) : null}
                </div>
            );
        }
        return (
            <div className="main-div-form">
                <div className="content-div-form">
                    <div className="div-form">{formContent}</div>
                </div>
                <div className="div-buttons-container">
                    <Button
                        variant="contained"
                        aria-label="Validate"
                        onClick={this.validate.bind(this)}
                        style={{ width: "100vw", backgroundColor: "#4F9E30" }}
                    >
                        Valider
                    </Button>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        form: state.equipmentEPI.currentEquipmentEPIForm,
        sections: state.equipmentEPI.equipmentEPIFormSections,
        activeUser: state.activeUser,
        currentEquipmentInspection: state.equipmentEPI.currentEquipmentInspection,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        responseValueChange: (sectionId, metaQuestion, sections) =>
            dispatch(responseValueChange(sectionId, metaQuestion, sections)),
        validateEquipmentInspection: (form, sections, equipmentInspection, user, history) =>
            dispatch(validateEquipmentInspection(form, sections, equipmentInspection, user, history)),
    };
};

export default compose(withAuth, connect(mapStateToProps, mapDispatchToProps))(EquipmentEPIForm);
